import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { colors } from '../constants';
import Box from '../components/box/Box'; // Ensure Box is correctly imported
import API_URLS from '../summaryapi/apiUrls'; // API URL for the backend

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const RevenueByMonthsChart = () => {
    const [chartData, setChartData] = useState(null);

    useEffect(() => {
        // Fetch the data from your backend API
        fetch(API_URLS.bookingReportAnalysis)
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    setChartData(data.monthlyData); // Set the fetched data into the state
                }
            })
            .catch(err => console.error('Error fetching booking report data:', err));
    }, []);

    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            x: {
                grid: {
                    display: false,
                    drawBorder: false,
                },
            },
            y: {
                grid: {
                    display: false,
                    drawBorder: false,
                },
            },
        },
        plugins: {
            legend: {
                display: false,
            },
            title: {
                display: false,
            },
        },
        elements: {
            bar: {
                backgroundColor: colors.orange, // Keeping the color as defined in your constants
                borderRadius: 20,
                borderSkipped: 'bottom',
            },
        },
    };

    return (
        <>
            <div className="title mb">Revenue by months</div>
            <div>
                {/* Render the Bar chart only when chartData is available */}
                {chartData ? (
                    <Bar options={chartOptions} data={chartData} height={`300px`} />
                ) : (
                    <p>Loading...</p>
                )}
            </div>
        </>
    );
};

const Analytics = () => {
    return (
        <div>
            <h1>Analytics</h1>
            <div className="row">
                <div className="col-12">
                    <Box>
                        <RevenueByMonthsChart />
                    </Box>
                </div>
            </div>
        </div>
    );
};

export default Analytics;
